/**
 * Implementação do repositório de Auth: delega clearCache ao datasource local.
 */

import type { AuthRepository } from '../../domain/repositories/auth-repository';
import type { AuthLocalDataSource } from '../datasources/local';

export class AuthRepositoryImpl implements AuthRepository {
  constructor(private readonly local: AuthLocalDataSource) {}

  async clearCache(): Promise<void> {
    await this.local.clearAllCache();
  }
}
